var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "49px",
    viewBox: "0 0 26 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-3",
    transform: "translate(-56.000000, -21.000000)",
    fill: "#4092F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-map-pin-copy-2",
    transform: "translate(56.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13,
    cy: 41,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0.777777778 C19.8835556,0.777777778 25.4444444,6.33866667 25.4444444,13.2222222 C25.4444444,18.2444444 22.7386667,24.1502222 19.7288889,28.7333333 C18.2248889,31.0231111 16.648,32.9893333 15.3431111,34.3582222 C14.6924444,35.0391111 14.104,35.5777778 13.6542222,35.9191111 C13.112,36.3155556 12.7742222,36.2462222 12.3475556,35.9191111 C11.896,35.5777778 11.3075556,35.0391111 10.6586667,34.3546667 C9.352,32.9857778 7.77511111,31.0213333 6.27111111,28.7315556 C3.26133333,24.1502222 0.555555556,18.2444444 0.555555556,13.2222222 C0.555555556,6.33866667 6.11644444,0.777777778 13,0.777777778 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin2);
export default __webpack_public_path__ + "static/media/map-pin_2.c73a8073b508a7d7a378da1ac62c6030.svg";
export { ForwardRef as ReactComponent };